import { DatePicker } from "rsuite";
import isAfter from 'date-fns/isAfter';
import { isBefore } from "date-fns";
import './Layout.css';

const DateInput = ({
    searchTxt,
    handleInput,
    placeholder,
    maxDate,
    minDate,
    label
}: {
    searchTxt: Date | null;
    maxDate?: Date | null;
    minDate?: Date | null;
    handleInput: (e: any) => void;
    placeholder: string;
    label: string
}) => (
    <div className="invite-input-wrapper">
        <label htmlFor="">{label}</label>
        <DatePicker
            style={{ width: '226px' }}
            format="dd/ MM/ yyyy"
            placeholder={placeholder}
            onChange={(e) => handleInput(e)}
            value={searchTxt}
            shouldDisableDate={(date) => {
                if (maxDate) {
                    return isBefore(date, maxDate);
                }
                if (minDate) {
                    return isAfter(date, minDate);
                }
                return false;
            }}
        />
    </div>
);

export default DateInput;